export type HeartCategory = 'all' | `${number}-${number}` | `${number}-`;

// 하트 개수(문자열)를 숫자(number) 또는 undefined로 파싱하는 헬퍼 함수
const parseHeartValue = (value?: string): number | undefined => {
  if (!value) return undefined;
  const num = parseInt(value, 10);
  return Number.isNaN(num) ? undefined : num;
};

export const computeHeartRange = (params: {
  heartCategory: HeartCategory | string;
  minHeart?: string;
  maxHeart?: string;
}): { startHeart?: number; endHeart?: number } => {
  const { heartCategory, minHeart, maxHeart } = params;

  // 카테고리 우선
  if (heartCategory !== 'all') {
    const [startStr, endStr] = heartCategory.split('-');
    const start = parseInt(startStr, 10);
    const end = endStr ? parseInt(endStr, 10) : undefined;
    return { startHeart: start, endHeart: end };
  }

  const parsedMin = parseHeartValue(minHeart);
  const parsedMax = parseHeartValue(maxHeart);

  return { startHeart: parsedMin, endHeart: parsedMax };
};
